var _mask, _mask2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnGrocery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 15 15",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.062.044h5.157v4.03h-5.157z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 14.977h14.979v-14.977h-14.979z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2c2c2c",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.79 13.866h-1.55v-.135c0-.492-.009-.985.002-1.478.019-.922-.637-1.766-1.587-1.977-.445-.1-.895-.073-1.347-.013 0-.163-.013-.328.003-.49.034-.342.294-.59.632-.64.114-.018.238-.045.33-.108.134-.09.157-.263.094-.41-.062-.147-.209-.235-.375-.226-.83.045-1.426.673-1.43 1.503v.368c-.558-.06-1.103-.092-1.653.095v-.155c0-1.457 0-2.915-.002-4.373 0-.062-.015-.13-.04-.187-.17-.39-.346-.779-.52-1.168-.01-.025-.016-.053-.03-.094h7.769c.441 0 .732.196.853.567.162.499-.19 1.02-.716 1.064-.323.026-.432.144-.432.471v7.387zm-9.044-3.464c0-.916-.72-1.64-1.64-1.649-.91-.009-1.65.732-1.65 1.65 0 .914.727 1.644 1.639 1.647.918.003 1.65-.729 1.65-1.648m1.455-3.262v.143c0 1.154.001 2.307-.002 3.461 0 .064-.024.14-.063.188-.319.385-.48.826-.482 1.325-.003.48 0 .96 0 1.441v.145h-5.645c-.003-.04-.007-.084-.007-.127 0-1.901 0-3.802-.002-5.703 0-.084.02-.132.102-.167.401-.176.791-.382 1.203-.53.523-.187 1.058-.132 1.559.094.5.226 1.01.357 1.56.328.36-.019.706-.095 1.034-.245.242-.11.48-.228.742-.353m-6.195-.094c0-.376-.001-.753.001-1.13 0-.035.02-.071.035-.104.595-1.296 1.192-2.591 1.784-3.888.039-.085.083-.112.173-.112.735.004 1.47.004 2.205 0 .09 0 .136.024.175.11.577 1.268 1.154 2.536 1.744 3.798.082.177.108.346.096.53-.002.034-.024.083-.05.096-.385.183-.762.39-1.16.534-.57.206-1.15.168-1.702-.087-.914-.424-1.823-.421-2.732.01-.178.084-.357.164-.536.246-.006.003-.016-.001-.033-.003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.264.144v.42c.003.232.167.405.377.4.212-.005.362-.17.364-.4v-.414c.06-.018.116-.043.174-.052.429-.062.86-.105 1.27.083.494.226.75.624.763 1.165.01.476.008.953 0 1.429-.012.685-.522 1.22-1.202 1.28-.41.037-.81.02-1.19-.166-.13-.064-.275-.06-.413.016-.356.196-.742.182-1.129.15-.407-.034-.734-.216-.98-.543-.141-.188-.223-.404-.227-.638-.007-.538-.013-1.076 0-1.614.014-.61.538-1.158 1.151-1.19.309-.017.62.023.93.04.035.002.07.021.112.035",
    mask: "url(#a)",
    transform: "translate(6.296 10.903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.281 1.076h3.639v-1.076h-3.639zm2.724 9.328c0-.51-.394-.91-.899-.916-.506-.006-.91.401-.909.917 0 .51.396.904.904.904.507 0 .904-.397.904-.905",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.005 10.404c0 .508-.397.905-.904.905-.508 0-.903-.395-.904-.904 0-.516.403-.923.909-.917.505.006.899.407.899.916",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGrocery);
export default __webpack_public_path__ + "static/media/icn_grocery.7ccc939000166053ef2b5ec469173a06.svg";
export { ForwardRef as ReactComponent };